import { all } from 'redux-saga/effects'

import { applicationSagas } from './applications'
import { authenticationSagas } from './authentication'
import { boostsSagas } from './boosts'
import { campaignSagas } from './campaigns'
import { campaignPartnersSagas } from './campaignPartners'
import { categoriesSagas } from './categories'
import { donationsSagas } from './donations'
import { emailActivitySagas } from './emailActivity'
import { faqsSagas } from './faqs'
import { feedbackSagas } from './feedback'
import { instagramBioLinksSagas } from './instagramBioLinks'
import { messagingSagas } from './messaging'
import { opportunitiesSagas } from './opportunities'
import { organisationsSagas } from './organisations'
import { paymentsSagas } from './payments'
import { peopleSagas } from './people'
import { personalGoalsSagas } from './personalGoals'
import { placesSagas } from './places'
import { platformEventsSagas } from './platformEvents'
import { searchSagas } from './search'
import { statsSagas } from './stats'
import { storiesSagas } from './stories'
import { subscriptionSagas } from './subscriptions'

//
// growsmart sagas
//
import { growsmartSagas } from './growsmart'

export default function* rootSaga() {
  yield all([
    ...applicationSagas,
    ...authenticationSagas,
    ...boostsSagas,
    ...campaignSagas,
    ...campaignPartnersSagas,
    ...categoriesSagas,
    ...donationsSagas,
    ...emailActivitySagas,
    ...faqsSagas,
    ...feedbackSagas,
    ...storiesSagas,
    ...instagramBioLinksSagas,
    ...messagingSagas,
    ...opportunitiesSagas,
    ...organisationsSagas,
    ...paymentsSagas,
    ...peopleSagas,
    ...placesSagas,
    ...platformEventsSagas,
    ...personalGoalsSagas,
    ...searchSagas,
    ...statsSagas,
    ...subscriptionSagas,
    //
    // growsmart sagas
    //
    ...growsmartSagas
  ])
}
